import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export default function ImageMarquee(el, {
    direction,
}) {
    const carousels = el.querySelectorAll('.swiper');
    const playPause = el.querySelector('button');
    const [play, pause] = playPause.children;

    const swipers = Array.from(carousels).map(c => new Swiper(c, { // eslint-disable-line no-new
        modules: [Autoplay],
        loop: true,
        slidesPerView: 'auto',
        freeMode: true,
        // speed: 1000,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            reverseDirection: direction === 'right',
        },
    }));

    playPause.onclick = () => {
        swipers.forEach(s => {
            if (s.autoplay.running) {
                s.setTranslate(s.getTranslate());
                s.autoplay.stop();
                play.style.display = 'block';
                pause.style.display = 'none';
            } else {
                s.slideToLoop(s.realIndex, 0);
                s.autoplay.start();
                play.style.display = 'none';
                pause.style.display = 'block';
            }
        });
    };
}
